import React, { useContext, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { NewPOAContext } from './new-poa-composer';

export function NewPOAGuard({ initLoad, setInitLoad }) {
  const { powerOfAttorney, checkpoint } = useContext(NewPOAContext);
  const navigate = useNavigate();

  console.log('NewPOAGuard', powerOfAttorney, checkpoint);

  useEffect(() => {
    if (initLoad) {
      setInitLoad(false);

      if (!powerOfAttorney) {
        return navigate('/people/self/life-documents/power-of-attorney/new');
      }

      if (powerOfAttorney && powerOfAttorney.status === 'draft') {
        if (checkpoint !== '') {
          return navigate(checkpoint, { replace: true });
        }

        return navigate('continue', { replace: true });
      }
    }
  }, [ initLoad, powerOfAttorney, navigate, setInitLoad, checkpoint ]);

  if (initLoad) {
    return <div>POA Guard Verification...</div>;
  }

  return <Outlet />;
}
